import { postData } from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import noOp from "@/data-models/no-op.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import { postGQL } from "@/util/gql-formatters.mjs";

export default function postRankUpdate(params: {
  summonerId: string;
  gameName: string;
  tagLine: string;
  region: string;
  rank: string;
  tier: string;
  leaguePoints: number;
  wins: number;
  losses: number;
  season: string;
  queue: string;
}) {
  const data = {
    region: params.region,
    summonerId: params.summonerId,
    summonerName: `${params.gameName}#${params.tagLine}`,
    queueType: params.queue,
    tier: params.tier,
    rank: params.rank,
    wins: params.wins,
    losses: params.losses,
    season: 15,
    leaguePoints: params.leaguePoints,
    leagueId: "",
    leagueName: "",
    series: "",
  };

  return postData(
    postGQL(appURLs.ANALYTICS, GraphQLTemplates.UpdateLeagueRank, data),
    noOp,
    undefined,
    undefined,
  );
}
